import Pickr from '@simonwep/pickr';
import '@simonwep/pickr/dist/themes/classic.min.css';   // 'classic' theme

import './colour.css';

class ColourBoxComponent {
    constructor(element, opacity) {
        this.previousParent = element.parentNode;

        const listeners = [];
        this.listeners = listeners;

        const callback = (color) => {
            listeners.forEach(e => e(color));
        }

		const pickr = Pickr.create({
			el: element,
			position: 'top-start', 
			margin: 16,
			inline: false,	
			components: {	
				// Main components
				preview: true,
				opacity: opacity,
				hue: true,
	
				// Input / output Options
				interaction: {
					hex: true,
					rgba: true,
					hsla: false,
					hsva: false,
					cmyk: false,
					input: true,
					clear: true,
					save: true
				}
			}
		});

        const my = this;
        pickr.on('change', (color, source, instance) => {
            my.cleared = color === null;
            let value = null;
            if (color) {
                value = color.toRGBA();
            }

            callback(value);
        });

		pickr.on('save', (color,  instance) => {
			my.cleared = color === null;	
			my.save = true;		
		});

		this.pickr = pickr;	
	
		const root = pickr.getRoot();		
		const listener = () => {
			const colour = pickr.getColor();
	
			if (colour) {
				pickr.setColor(pickr.getColor().toRGBA().toString());
			}
			
			root.button.removeEventListener('click', listener);
		}; 
		
		root.button.addEventListener('click', listener);
	}
	
	addListener(listener) {
		this.listeners.push(listener);
	}
	
	setValue(value) {
	    clearTimeout(this.colourTimeout);

	    //async in case animation frame of pickr is delayed
	    const my = this;
	    
	    this.colourTimeout = setTimeout(() => my.pickr.setColor(value), 50);
    }
	
	enable() {
		this.pickr.enable();
	}
	
	disable() {
		this.pickr.disable();
	}
	
	destroyAndRemove(element) {
	    clearTimeout(this.colourTimeout);
		 this.pickr.destroyAndRemove();
		 this.pickr = null;
		 
		 if( !element.parentNode && this.previousParent ) {
         	this.previousParent.appendChild(element);
         } 
	}
	
	getValue() {
		const colour = this.pickr.getColor();    
	  	if( this.save && !this.cleared && colour ) {
        	return colour.toRGBA();
     	}
	}
	
	setVisible(visible) {
		let root = this.pickr.getRoot();
        root.root.style.display = visible ? '' : 'none';
	}	
}

const ColourBox = (element, withOpacity) => {
	return new ColourBoxComponent(element, withOpacity);
};

export {
	ColourBox
}